/* Lit For label renderer. Shared by the product page preview and the print-file
   service, so the preview is exactly what prints.
   drawLitFor(ctx, baseImage, {name, years, line, scent}, scale, size)
   size is 9 (900x600 label) or 4 (612x531 label); default 9.
   Coordinates are in label units; scale 2 gives the print file (1800x1200 or 1224x1062).
   Fonts required: "BIW Lit Title" (name), "Arimo" (years, line), "Arimo Bold" (scent). */
(function (root) {
  var NAME_FONT = '"BIW Lit Title"', BODY_FONT = 'Arimo', BOLD_FONT = '"Arimo Bold"';
  var GEOM = {
    9: { W: 900, H: 600, TOP: 128, BOTTOM: 362, SCENT_Y: 400, SCENT_PX: 21, CX: 450, NAME_W: 600, LINE_W: 540,
         NAME_MAX: 84, NAME_MIN: 46, NAME2_MAX: 62, NAME2_MIN: 30,
         YEARS_PX: 22, YEARS_SP: 2.5, LINE_PX: 24, LINE_LH: 32,
         GAPS: { 'name-years': 30, 'name-line': 30, 'years-line': 26 } },
    4: { W: 612, H: 531, TOP: 100, BOTTOM: 324, SCENT_Y: 356, SCENT_PX: 18, CX: 306, NAME_W: 470, LINE_W: 470,
         NAME_MAX: 72, NAME_MIN: 40, NAME2_MAX: 54, NAME2_MIN: 28,
         YEARS_PX: 20, YEARS_SP: 2.2, LINE_PX: 21, LINE_LH: 28,
         GAPS: { 'name-years': 26, 'name-line': 26, 'years-line': 22 } }
  };

  function clean(s, max) {
    s = String(s || '').replace(/'/g, '’');
    return s.replace(/\s+/g, ' ').trim().slice(0, max);
  }

  // Lines read as a sentence: capital first, period last.
  function sentence(s) {
    if (!s) return s;
    s = s.charAt(0).toUpperCase() + s.slice(1);
    if (!/[.!?…]$/.test(s)) s += '.';
    return s;
  }

  // Scent as the other candle labels show it: caps, "and" written as "+".
  function scentLabel(s) {
    s = String(s || '').replace(/\s+/g, ' ').trim();
    if (!s) return '';
    return s.replace(/ and /gi, ' + ').toUpperCase().slice(0, 40);
  }

  function spacedWidth(ctx, text, spacing) {
    return ctx.measureText(text).width + spacing * Math.max(0, text.length - 1);
  }

  function drawSpaced(ctx, text, cx, y, spacing) {
    var w = spacedWidth(ctx, text, spacing), x = cx - w / 2;
    ctx.textAlign = 'left';
    for (var i = 0; i < text.length; i++) {
      ctx.fillText(text[i], x, y);
      x += ctx.measureText(text[i]).width + spacing;
    }
  }

  function nameLayout(ctx, name, g) {
    var size, words = name.split(' ');
    for (size = g.NAME_MAX; size >= g.NAME_MIN; size -= 2) {
      ctx.font = size + 'px ' + NAME_FONT;
      if (ctx.measureText(name).width <= g.NAME_W) return { size: size, lines: [name] };
    }
    if (words.length > 1) {
      var best = null;
      for (var i = 1; i < words.length; i++) {
        var a = words.slice(0, i).join(' '), b = words.slice(i).join(' ');
        ctx.font = '60px ' + NAME_FONT;
        var m = Math.max(ctx.measureText(a).width, ctx.measureText(b).width);
        if (!best || m < best.m) best = { m: m, lines: [a, b] };
      }
      for (size = g.NAME2_MAX; size >= g.NAME2_MIN; size -= 2) {
        ctx.font = size + 'px ' + NAME_FONT;
        if (ctx.measureText(best.lines[0]).width <= g.NAME_W && ctx.measureText(best.lines[1]).width <= g.NAME_W)
          return { size: size, lines: best.lines };
      }
      return { size: g.NAME2_MIN, lines: best.lines };
    }
    for (size = g.NAME_MIN; size > 16; size -= 2) {
      ctx.font = size + 'px ' + NAME_FONT;
      if (ctx.measureText(name).width <= g.NAME_W) break;
    }
    return { size: size, lines: [name] };
  }

  function wrap(ctx, text, maxW) {
    var words = text.split(' '), lines = [], cur = '';
    for (var i = 0; i < words.length; i++) {
      var t = cur ? cur + ' ' + words[i] : words[i];
      if (ctx.measureText(t).width > maxW && cur) { lines.push(cur); cur = words[i]; } else cur = t;
    }
    if (cur) lines.push(cur);
    return lines;
  }

  function drawLitFor(ctx, base, data, scale, size) {
    scale = scale || 1;
    var g = GEOM[size === 4 || size === '4' ? 4 : 9];
    var name = clean(data.name, 24).toUpperCase();
    var years = clean(data.years, 15);
    var line = sentence(clean(data.line, 44));
    var scent = scentLabel(data.scent);
    ctx.save();
    ctx.setTransform(scale, 0, 0, scale, 0, 0);
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, g.W, g.H);
    if (base) ctx.drawImage(base, 0, 0, g.W, g.H);
    ctx.fillStyle = '#000';
    ctx.textBaseline = 'alphabetic';

    var blocks = [];
    if (name) {
      var nl = nameLayout(ctx, name, g);
      blocks.push({ kind: 'name', layout: nl, h: nl.size * 0.8 + (nl.lines.length - 1) * nl.size * 1.0 });
    }
    if (years) blocks.push({ kind: 'years', h: g.YEARS_PX * 0.77 });
    if (line) {
      ctx.font = g.LINE_PX + 'px ' + BODY_FONT;
      var ll = wrap(ctx, line, g.LINE_W).slice(0, 2);
      blocks.push({ kind: 'line', lines: ll, h: g.LINE_PX * 0.75 + (ll.length - 1) * g.LINE_LH });
    }
    if (scent) {
      ctx.textAlign = 'center';
      ctx.font = g.SCENT_PX + 'px ' + BOLD_FONT;
      ctx.fillText(scent, g.CX, g.SCENT_Y);
    }

    var total = 0, i, j;
    for (i = 0; i < blocks.length; i++) {
      total += blocks[i].h;
      if (i) total += g.GAPS[blocks[i - 1].kind + '-' + blocks[i].kind];
    }
    var y = g.TOP + (g.BOTTOM - g.TOP - total) / 2;
    for (i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (i) y += g.GAPS[blocks[i - 1].kind + '-' + b.kind];
      ctx.textAlign = 'center';
      if (b.kind === 'name') {
        ctx.font = b.layout.size + 'px ' + NAME_FONT;
        for (j = 0; j < b.layout.lines.length; j++)
          ctx.fillText(b.layout.lines[j], g.CX, y + b.layout.size * 0.8 + j * b.layout.size * 1.0);
      } else if (b.kind === 'years') {
        ctx.font = g.YEARS_PX + 'px ' + BODY_FONT;
        drawSpaced(ctx, years, g.CX, y + g.YEARS_PX * 0.73, g.YEARS_SP);
      } else {
        ctx.font = g.LINE_PX + 'px ' + BODY_FONT;
        for (j = 0; j < b.lines.length; j++) ctx.fillText(b.lines[j], g.CX, y + g.LINE_PX * 0.75 + j * g.LINE_LH);
      }
      y += b.h;
    }
    ctx.restore();
  }

  root.drawLitFor = drawLitFor;
  root.litForSentence = sentence;
  root.litForGeom = GEOM;
  root.litForScent = scentLabel;
  if (typeof module !== 'undefined' && module.exports) module.exports = { drawLitFor: drawLitFor, sentence: sentence, scentLabel: scentLabel, GEOM: GEOM };
})(typeof window !== 'undefined' ? window : globalThis);
